import { useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useAuth } from '@/api';
import { PostLoginLandingPage } from '@/common/components/Forex/components/landing-page/PostLogin';
import PreLoginLandingPage from '@/common/components/Forex/components/landing-page/PreLogin';
import { useForexStore } from '@/common/components/Forex/store/store';

const LandingPage = () => {
  const { isLoggedIn } = useAuth();

  const [resetState] = useForexStore((state) => [state.resetState], shallow);

  useEffect(() => {
    resetState();
  }, []);

  if (isLoggedIn) {
    return <PostLoginLandingPage />;
  }

  return <PreLoginLandingPage />;
};

export default LandingPage;
